import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './AppContext';

import LoginPage from './pages/LoginPage';
import CustomerListPage from './pages/CustomerListPage';
import ServiceConfigPage from './pages/ServiceConfigPage';
import OverviewExportPage from './pages/OverviewExportPage';
import ConfigurePage from './pages/ConfigurePage';
import Navbar from './components/Navbar';

function App() {
  return (
    <AppProvider>
      <Router>
        <div>
          <Navbar />
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/customers" element={<CustomerListPage />} />
            <Route path="/configure" element={<ConfigurePage />} />
            <Route path="/services/:customerId" element={<ServiceConfigPage />} />
            <Route path="/overview/:customerId" element={<OverviewExportPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;
